<!--
<SearchableInput
  @change="choosenId = $event"
  :options="{'id1':'Val #1', 'id2': 'Val #2'}"
  placeholder="Sök efter..."
/>
-->
<template>
  <div>
    <input
      v-model="searchFor"
      autocomplete="off"
      @focus="showDropdown = true"
      :class="{ input: true }"
      v-bind="$attrs"
      type="text"
      id="search-input" />
    <div v-if="dropdown" class="dropdown-wrapper">
      <ul
        class="dropdown"
        v-if="showDropdown && searchFor.length >= 1 && Object.keys(matchingOptions).length > 0"
        id="list">
        <span class="search-suggestion">Sökförslag:</span>
        <li
          tabindex="0"
          v-for="(title, key) in matchingOptions"
          v-bind:key="key"
          @click="select(key)"
          @focus="scrollTo">
          <span v-html="highlight(title)" @click="select(key)" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VueClickAway from 'vue3-click-away';

export default {
  name: 'SearchableInput',
  mixins: [VueClickAway],
  props: {
    options: {
      type: Object,
      required: true,
    },

    /**
     * Ska dropdownen visas? Eveneutllt vill man bara lyssna på "match" och filtera själv
     */
    dropdown: {
      type: Boolean,
      default: true,
    },

    replacements: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      currentIndex: 1,
      searchFor: '',
      showDropdown: false,

      // jag lyckas inte få replacements att vara en property man kan använda direkt.
      // webbläsaren kraschar.
      internal_replacements: this.replacements,
    };
  },

  watch: {
    matchingOptions(matches) {
    //  this.$emit('match', Object.keys(matches));
    },
  },

  mounted() {
    document.addEventListener('keyup', this.nextItem);
  },

  computed: {
    searchTerms() {
      return (
        this.searchFor

          // matcha på stora och små bokstäver
          .toLowerCase()

          // sök på alla ord
          .split(' ')

          // Ersätt eventuella ord.
          // Skriver man "betald" matchar den både "obetald" och "betald" och därför kan man ersätta "betald" med "#betald#"
          .map((term) => {
            if (term && this.internal_replacements && this.internal_replacements[term])
              return this.internal_replacements[term];

            return term;
          })
      );
    },

    matchingOptions() {
      let matches = {};
      Object.keys(this.options).forEach((key) => {
        this.searchTerms.forEach((term) => {
          if (this.options[key].toLowerCase().indexOf(term) > -1) matches[key] = this.options[key];
        });
      });
      return matches;
    },
  },

  methods: {
    blur() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 150);
    },
    select(what, title) {
      if (Number.isInteger(what)) {
        what = what - 2;
        what = Object.keys(this.matchingOptions)[what];
      }

      this.showDropdown = false;
      this.searchFor = this.options[what];
      this.$emit('changes', what)
      this.currentIndex = 1;
      $('#error-report-contact-person-input').focus();
    },
    highlight(title) {
      var RegE = new RegExp(this.searchFor, 'gi');
      let matches = title.match(RegE);

      if (matches == null) return title;

      matches.forEach((match) => {
        // wrappar match med ^ och $ som sedan ersätts med <strong>..</strong>
        title = title.replace(match, '^' + match + '$');
      });

      title = title.replace(/\^/g, '<strong>').replace(/\$/g, '</strong>');

      return title;
    },

    /**
     * Disables default scroll on focus and tries to fix the visual error where a focues item is outside of its parent
     */
    scrollTo($event) {
      $event.target.focus({ preventScroll: true });

      setTimeout(() => {
        const targetTop =
          $event.target.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
        const parentTop =
          $event.target.parentNode.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top;
        const targetBottom =
          $event.target.getBoundingClientRect().bottom -
          document.body.getBoundingClientRect().bottom;
        const parentBottom =
          $event.target.parentNode.getBoundingClientRect().bottom -
          document.body.getBoundingClientRect().bottom;

        if (parentTop - targetTop > 0) {
          $event.target.parentNode.scrollTop =
            $event.target.parentNode.scrollTop - $event.target.parentNode.offsetHeight / 2;
        } else if (targetBottom - parentBottom > 0) {
          $event.target.parentNode.scrollTop =
            $event.target.parentNode.scrollTop + $event.target.parentNode.offsetHeight / 2;
        }
      }, 100);
    },
    nextItem() {
      if (this.searchFor.length >= 0) {
        switch (event.keyCode || event.which) {
          //Down button
          case 40:
            this.currentIndex++;
            $('#list li:nth-child(' + this.currentIndex + ')').focus();
            break;
          //Up button
          case 38:
            if (this.currentIndex > 2) {
              this.currentIndex--;
              $('#list li:nth-child(' + this.currentIndex + ')').focus();
            } else {
              this.currentIndex = 1;
              document.getElementById('search-input').focus();
            }
            break;
          //Backspace button
          case 8:
            if (this.searchFor.length < 1) {
              this.currentIndex = 1;
            }
            break;
          //Delete button
          case 46:
            if (this.searchFor.length < 1) {
              this.currentIndex = 1;
            }
            break;
          //Tab button
          case 9:
            if (document.getElementById('list')) {
              if (document.getElementById('list').contains(document.activeElement)) {
                this.showDropdown = false;
                this.currentIndex = 1;
                $('#contact-person-input').focus();
              }
            }
            break;
          //Enter button
          case 13:
            if (this.currentIndex > 1) this.select(this.currentIndex);
            break;
          //Any other button
          default:
            break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown-wrapper {
  position: relative;

  .dropdown {
    position: absolute;
    z-index: 10;
    max-height: 250px;
    overflow-y: scroll;
    top: 0;
    width: 100%;
    background: #fff;
    padding: 10px 10px;
    border: 1px solid #f0f0f0;

    li {
      padding-bottom: 5px;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      &:focus {
        text-decoration: underline;
      }
    }

    .search-suggestion {
      font-style: italic;
    }
  }
}

label {
  margin-bottom: 4px;
  display: inline-block;
  margin-top: 16px;
}


input, textarea {
  width: 100%;
  max-width: 600px;
  margin-top: 7px !important;
  margin-bottom: 8px;
  padding: 7.5px 10px !important;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  font-size: 1.4rem;
  line-height: 1.6;
  outline: none;
  transition: box-shadow .15s linear;
}
</style>
